import React from "react";

const Header = () => {
  return (
    <header className="header">
      <div className="avatar-container">
        <img
          src="/dana-avatar.png"
          alt="Dana's Avatar"
          className="avatar-image"
          onError={(e) => {
            e.target.style.display = "none";
            const fallback = e.target.nextSibling;
            if (fallback) {
              fallback.style.display = "block";
            }
          }}
        />
        <span style={{ display: "none", fontSize: "4rem" }}>👩‍🍳</span>
      </div>
      <h1>These Foods Don't Bite! 🕵️‍♀️</h1>
      <p>
        Dana's sassy food detective will tell you what's safe, girlfriend! 💅
      </p>
    </header>
  );
};

export default Header;
